import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, touch } from 'redux-form';
import FileInput from '../form-controls/FileInputNew';
import { fileSizeCheckInMB } from '../../utils/validation';
import { getFileExtension, checkFieldInFormSection } from '../../utils/library';
import './file-upload-links.css';
import {
  FILE_FORMAT_PDF_IMAGE,
  FILE_FORMAT_EXT_IMAGE_ONLY,
  SAMPLE_DOC_IMAGE,
  DEVICE_MOBILE,
  ADDRESS_POA_DOCUMENT,
  ADDRESS_WITH_SUPPORTING_DOCS
} from '../../utils/constants';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import CommonButton from '../common-button/CommonButton';
import {
  CHECKED_ICON,
  CLOSE_POPUP_ICON,
  PDF_ICON,
  SAMPLE,
  SAMPLE_ICON,
  YOUR_SIGNATURE_ICON
} from '@Images';

class PhotoUploadLinks extends React.Component {
  constructor(props) {
    super(props);
    this.validateFor = props.validate || FILE_FORMAT_PDF_IMAGE;

    this.state = { isTakeAPicture: false };
    this.sampleLinkRef = {};
  }

  showCapture = () => {
    this.webcamCapture.showCapture();
  };

  fileChange = (fileObj) => {
    // eslint-disable-next-line no-prototype-builtins
    if (fileObj.hasOwnProperty('webcamData')) {
      this.setState({ isTakeAPicture: true });
    } else {
      this.setState({ isTakeAPicture: false });
    }
    this.props.onChangeFile(fileObj);
  };

  componentDidUpdate = (prevProps) => {
    let { linkEle, formName } = this.props;
    let { linkEle: linkp } = prevProps;
    if (
      linkp.file_field_name === linkEle.file_field_name &&
      (linkp.fileSrc !== linkEle.fileSrc || linkp.fileSrcBack !== linkEle.fileSrcBack) &&
      (linkEle.fileSrc || linkEle.fileSrcBack)
    ) {
      this.props.dispatch(touch(formName, linkEle.file_field_name));
      this.props.dispatch(touch(formName, linkEle.file_field_name + '_back'));
    }
  };

  validateReq = (value, allValues, props, field_name) => {
    if (!value) {
      return 'Required';
    } else {
      return this.validate(value, allValues, props, field_name);
    }
  };

  validate = (value, allValues, props, field_name) => {
    let isFileRequired = checkFieldInFormSection(allValues, field_name, 2, 'doc_file');
    let isDocDisabled =
      (props.disablePoi && field_name.includes('POI')) ||
      (props.disablePoa && field_name.includes('POA'))
        ? true
        : false;
    if (isFileRequired && !value && !isDocDisabled) {
      return 'Required';
    }
    if (!value) {
      return undefined;
    } else {
      if (value && (value instanceof File || value instanceof Blob)) {
        let isInvalidFile = !this.validateFor.includes(`${value.binaryFileType || value.type}`);
        if (isInvalidFile) {
          let fileTypes =
            this.validateFor.length === 1
              ? this.validateFor[0]
              : this.validateFor.reduce((acc, type, index) => {
                  switch (this.validateFor.length - index) {
                    case 1:
                      return (acc += `${type}`);
                    case 2:
                      return (acc += `${type} and `);
                    default:
                      return (acc += `${type}, `);
                  }
                }, []);
          return `Only ${fileTypes} file types are allowed`;
          // eslint-disable-next-line
        } else {
          return fileSizeCheckInMB(value.size, 5);
        }
      }
    }
  };

  showImageOnly = ({ docTypeString, linkEle }) => {
    let isInitPDF = false;
    const { toggleFeature, smallPreview } = this.props;
    let { actual_file_name, actual_file_name_back, is_back_file, fileSrc, fileSrcBack } = linkEle;
    if ((is_back_file && !fileSrcBack) || (!is_back_file && !fileSrc)) return null;
    if (actual_file_name || actual_file_name_back) {
      let fileExt = getFileExtension(is_back_file ? actual_file_name_back : actual_file_name);
      if (fileExt && fileExt === '.pdf') isInitPDF = true;
    }
    if (!isInitPDF) {
      return <img src={is_back_file ? fileSrcBack : fileSrc} alt={`${docTypeString}`} />;
    }
    if (toggleFeature && isInitPDF) {
      return (
        <div className="pdf-viewer">
          <img src={PDF_ICON} alt={`${docTypeString}`} />
          {!smallPreview && (
            <p className="pdf-text">{is_back_file ? actual_file_name_back : actual_file_name}</p>
          )}
        </div>
      );
    } else return null;
  };

  fileExtension = ({ fileEle }) => {
    let fileExt;
    if (fileEle) {
      let { actual_file_name, actual_file_name_back, is_back_file, fileSrc, fileSrcBack } = fileEle;
      if ((is_back_file && !fileSrcBack) || (!is_back_file && !fileSrc)) return null;
      if (actual_file_name || actual_file_name_back) {
        fileExt = getFileExtension(is_back_file ? actual_file_name_back : actual_file_name);
      }
    }
    return fileExt;
  };

  isLargeImageLayout = ({ fileEle }) => {
    let fileExt = this.fileExtension({ fileEle });
    fileExt = fileExt && fileExt.toLowerCase();
    if (FILE_FORMAT_EXT_IMAGE_ONLY.indexOf(fileExt) !== -1) {
      return true;
    }
  };
  getPopupImage = (linkEle, isBackImage) => {
    const { document_code } = linkEle;
    let frontKey = document_code;
    if (isBackImage) {
      frontKey = `${frontKey}_BACK`;
    }
    return SAMPLE_DOC_IMAGE[frontKey] ? SAMPLE_DOC_IMAGE[frontKey] : SAMPLE;
  };
  render() {
    let {
      linkEle,
      docTypeString,
      clearFile,
      index,
      country_code,
      disableForm,
      hideImages,
      toggleFeature,
      onSampleClick,
      device,
      showSampleImageFlag = true,
      smallPreview
    } = this.props;
    let renderArr = [];
    linkEle.is_back_file = false;
    linkEle.label_text = `${linkEle.label}  ${linkEle.is_back_required ? 'Front' : ''}`;
    if (!linkEle.is_back_document) renderArr.push(linkEle);
    if (linkEle.is_back_required || linkEle.is_back_document) {
      let linkElecp = { ...linkEle };
      linkElecp.file_field_name += '_back';
      linkElecp.is_back_file = true;
      linkElecp.label_text = `${linkEle.label} Back`;
      renderArr.push(linkElecp);
    }
    return renderArr.map((Ele, incrementedValue) => {
      let src = null,
        clearOnly = null,
        display_file_name = null;
      src = Ele.is_back_file ? Ele.fileSrcBack : Ele.fileSrc;
      clearOnly = Ele.is_back_file ? 'fileSrcBack' : 'fileSrc';
      display_file_name = Ele.is_back_file ? Ele.actual_file_name_back : Ele.actual_file_name;
      const popupImage = this.getPopupImage(linkEle, Ele.is_back_file);
      const isVisible = Ele.show_upload_button || Ele.show_capture_button;
      return (
        isVisible && (
          <div
            key={incrementedValue}
            className={toggleFeature ? 'updc-upload-container' : 'div-parent-links cf'}
          >
            <div className="left-content" style={toggleFeature ? { width: '100%' } : {}}>
              {disableForm && <div className="disable-overlay" />}

              {![ADDRESS_POA_DOCUMENT, ADDRESS_WITH_SUPPORTING_DOCS, 'VISA_POI_DOCUMENT'].includes(
                Ele?.document_code
              ) ? (
                <p className={toggleFeature ? 'updc-upload-label' : 'upload_doc_txt'}>
                  {Ele.label_text}
                </p>
              ) : null}
              {(toggleFeature || country_code === 'IN') && showSampleImageFlag && !src && (
                <div className="sample-link-container">
                  <img src={SAMPLE_ICON} className="sample-icon" alt="icon" />
                  {device === DEVICE_MOBILE ? (
                    <CommonButton
                      text="View sample"
                      type="link"
                      ref={(ref) =>
                        (this.sampleLinkRef[`ref_${Ele.label_text.toLowerCase()}`] = ref)
                      }
                      onClick={() =>
                        onSampleClick(
                          this.sampleLinkRef[`ref_${Ele.label_text.toLowerCase()}`],
                          Ele.is_back_file,
                          Ele.label_text
                        )
                      }
                    />
                  ) : (
                    <Popup
                      trigger={<CommonButton text="View sample" type="link" />}
                      hideOnScroll={true}
                      hoverable={true}
                    >
                      <Popup.Content>
                        {country_code === 'IN' && Ele.document_code !== 'PAN' ? (
                          <div className="sample-modal">
                            <div className="image-text-div">
                              <img src={popupImage} alt="sample" style={{ marginTop: '40px' }} />
                              <div className="notes" id="notes">
                                <span className="self-text">Self attestation required</span>
                                <img
                                  alt="signature"
                                  src={YOUR_SIGNATURE_ICON}
                                  className="signature-img"
                                ></img>
                                <span className="write-your-name">Write your name</span>
                                <span className="write-your-name">Current date</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <img src={popupImage} alt="sample" />
                        )}
                      </Popup.Content>
                    </Popup>
                  )}
                </div>
              )}
              {!toggleFeature && src ? (
                this.isLargeImageLayout({ fileEle: Ele }) ? (
                  <div className="cf thumb-nail-image-section">
                    <div className="thumb-nail-image">
                      {' '}
                      {!hideImages &&
                        this.showImageOnly({
                          docTypeString,
                          linkEle: Ele
                        })}{' '}
                    </div>
                    <div className="upload-status-and-name-container">
                      <div className="upload-status-container">
                        <p className="upload-status-text">Uploaded</p>
                        <img src={CHECKED_ICON} alt="Uploaded" className="checked-icon" />
                      </div>
                      <div className="name-container">
                        <p className="file-name">{display_file_name}</p>
                        {!disableForm && (
                          <div
                            className="close-icon"
                            onClick={() =>
                              clearFile({
                                docType: docTypeString,
                                index,
                                setState: true,
                                fileName: Ele.file_field_name,
                                clearOnly
                              })
                            }
                          >
                            <img src={CLOSE_POPUP_ICON} alt="Close Icon" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="upload-link-img">
                    {!hideImages && this.showImageOnly({ docTypeString, linkEle: Ele })}
                    <div className="actual-file-name">
                      {display_file_name}
                      {!disableForm && (
                        <button
                          className="btn-cross"
                          type="button"
                          onClick={() =>
                            clearFile({
                              docType: docTypeString,
                              index,
                              setState: true,
                              fileName: Ele.file_field_name,
                              clearOnly
                            })
                          }
                        >
                          x
                        </button>
                      )}
                    </div>
                  </div>
                )
              ) : null}
              {toggleFeature && src && !smallPreview && (
                <div className={`updc-image-container`}>
                  {this.showImageOnly({ docTypeString, linkEle: Ele })}
                  <button
                    className="remove"
                    type="button"
                    onClick={() =>
                      clearFile({
                        docType: docTypeString,
                        index: 0,
                        setState: true,
                        fileName: Ele.file_field_name,
                        clearOnly
                      })
                    }
                  >
                    Remove
                  </button>
                </div>
              )}
              {toggleFeature && src && smallPreview && (
                <div className={`updc-small-image-container`}>
                  {this.showImageOnly({ docTypeString, linkEle: Ele })}
                  <button
                    className="remove"
                    type="button"
                    onClick={() =>
                      clearFile({
                        docType: docTypeString,
                        index: 0,
                        setState: true,
                        fileName: Ele.file_field_name,
                        clearOnly
                      })
                    }
                  >
                    Remove
                  </button>
                </div>
              )}
              {((toggleFeature && !src) || !toggleFeature) && (
                <div className="links-wrapper">
                  {
                    <Field
                      {...this.props}
                      validate={Ele.is_mandatory ? [this.validateReq] : [this.validate]}
                      name={Ele.file_field_name}
                      fileUploadName={Ele.file_field_name}
                      showUploadBtn={Ele.show_upload_button}
                      component={FileInput}
                      toggleFeature={toggleFeature}
                      disabled={disableForm}
                      countryCode={country_code}
                      currentScreen={this.props.currentScreen}
                      accountType={this.props.account_type}
                      type={'file'} //initialization logic goes here
                      onChangeFile={(result) =>
                        this.fileChange({
                          docTypeString,
                          document_code: Ele.document_code,
                          type: Ele.type,
                          is_back_file: Ele.is_back_file,
                          ...result
                        })
                      }
                      validateFor={this.validateFor}
                      fileSizeCheckInMB={fileSizeCheckInMB}
                      isTakeAPicture={this.state.isTakeAPicture}
                      showCaptureBtn={Ele.show_capture_button}
                    />
                  }
                </div>
              )}
            </div>
            {!toggleFeature && src && this.isLargeImageLayout({ fileEle: Ele }) ? (
              <div className="right-content">
                {!hideImages && this.showImageOnly({ docTypeString, linkEle: Ele })}
              </div>
            ) : null}
          </div>
        )
      );
    });
  }
}

PhotoUploadLinks.propTypes = {
  linkEle: PropTypes.object,
  docTypeString: PropTypes.string,
  onChangeFile: PropTypes.func,
  clearFile: PropTypes.func,
  index: PropTypes.number,
  country_code: PropTypes.string,
  disableForm: PropTypes.bool,
  currentScreen: PropTypes.string,
  account_type: PropTypes.string,
  formName: PropTypes.string,
  dispatch: PropTypes.func,
  validate: PropTypes.array,
  hideImages: PropTypes.bool,
  isShowSamplePhoto: PropTypes.func,
  toggleFeature: PropTypes.any,
  onSampleClick: PropTypes.func,
  device: PropTypes.string,
  showSampleImageFlag: PropTypes.bool,
  uploadImage: PropTypes.string,
  smallPreview: PropTypes.bool
};

export default connect()(PhotoUploadLinks);
